import React from "react";
import "./ErrorPage.css";
import { Box } from "@mui/material";
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import img404 from "../asset/403img.jpg";

const Error403Page = () => {
  return (
    <>
    <div style={{ height: "100%", margin: "0", padding:"0"}}>
    <div style={{display: "flex",flexDirection: "column", minHeight: "100vh", width: "100%"}}>
      <Header isVisible={true} buttonsVisible={true} />
      <div style={{flex: "1"}}>
      <Box>
        <div className="headtext1">
          <div className="headimg1">
            <img src={img404} alt="403 error page"/>
             <div className="textonimg1">
            <h2 id="shadow">
              Hey , you are not authorized to view this page . . . !
            </h2>
          </div>
          </div>

         
        </div>
      </Box>
      </div>
      <div style={{ position:"relative", bottom:"0"}}>
      <Footer />
      </div>
    </div>
    </div>
    </>
  );
};

export default Error403Page;
